import { Box, Button, Chip, Hidden, IconButton, Modal, Stack, Typography } from '@mui/material';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React, { useEffect, useState } from 'react';
import Image from '../../../../assets/images/dashboard/freemium-register-dark.png';
import { useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_HAS_VIEWED_INTEGRATION } from 'schemas/mutation';
import { SET_MODAL_STATUS, SET_MODAL_TYPE, SET_SELECTED_NAV_ITEM, SET_USER_DATA } from 'store/actions';
import { checkIsFreemiumPlan, checkIsPremiumPlan } from 'helper/checkPlan.helper';
import { useNavigate } from 'react-router';
import { setCurrentPage } from 'store/ExecutiveTeam/actions';

import QuestionAnimationVideo from 'assets/media/questionAnimatingVideo.mp4';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '775px',
    bgcolor: '#ffffff',
    boxShadow: '0px 0px 15px 0px rgba(0, 5, 124, 0.13)',
    borderRadius: '12px',
    p: 5
};

const IntegrateDiologQuestions = ({ hasClickedIntegration }) => {
    const [open, setOpen] = useState(false);
    const [isDelayed, setIsDelayed] = useState(false);

    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        vertical: true,
        autoplay: true,
        autoplaySpeed: 200,
        speed: 10000,
        slidesToScroll: 1,
        cssEase: 'linear',
        accessibility: false,
        touchMove: false
    };
    const { userData, firstTimeLogin, companyData } = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const { companyCreator } = useSelector((state) => state.authentication);

    const dispatch = useDispatch();
    const [updateIntegrateDiologModalViewedStatus] = useMutation(UPDATE_HAS_VIEWED_INTEGRATION);

    const onClickButton = () => {
        if (checkIsFreemiumPlan(companyData?.subscription?.plan)) {
            if (!companyCreator) {
                dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                dispatch({ type: SET_MODAL_TYPE, modalType: 'non_permit_upgrade' });
            } else navigate(`update-plan`);
        } else {
            dispatch({ type: setCurrentPage, currentPage: 'integrate-diolog' });
            navigate('company-profile/integrate-diolog/web-form');
        }
        handleCloseModal();
    };
    const handleCloseModal = async () => {
        setOpen(false);
        if (userData?.hasViewedIntegrationModal) return;
        if (userData?.hasClickedIntegration) return;

        try {
            const response = await updateIntegrateDiologModalViewedStatus({
                variables: {
                    updateIntegrateModalSeenInput: {
                        hasViewedIntegrationModal: true
                    }
                }
            });
            const { updateIntegrationModalSeen } = response.data;
            dispatch({
                type: SET_USER_DATA,
                userData: {
                    ...userData,
                    hasViewedIntegrationModal: Boolean(updateIntegrationModalSeen?.hasViewedIntegrationModal)
                }
            });
            const localStorageUserData = localStorage?.getItem('diologUserData') || null;
            if (localStorageUserData) {
                const modifiedUserData = JSON.parse(localStorageUserData);
                modifiedUserData.hasViewedIntegrationModal = Boolean(updateIntegrationModalSeen?.hasViewedIntegrationModal);
                localStorage.setItem(
                    'diologUserData',
                    JSON.stringify({
                        ...modifiedUserData,
                        hasViewedIntegrationModal: Boolean(updateIntegrationModalSeen?.hasViewedIntegrationModal)
                    })
                );
            }
        } catch (e) {
            console.log(e);
        }
    };

    // const handleAnimationIteration = () => {
    //     setIsDelayed(!isDelayed);
    // };

    // const handleAnimationEnd = () => {
    //     setTimeout(() => {
    //         setIsDelayed(true);
    //     }, 5000);
    // };

    useEffect(() => {
        function playVideo() {
            let animVideo = document.getElementById('video');
            if (animVideo) {
                animVideo.play();
            }
        }
        playVideo();
    }, [open]);

    useEffect(() => {
        if (userData?.hasOwnProperty('hasViewedIntegrationModal')) {
            if (!userData?.hasViewedIntegrationModal && !firstTimeLogin) {
                setOpen(true);
            }
        }
    }, [firstTimeLogin, userData]);

    useEffect(() => {
        if (userData?.hasOwnProperty('hasClickedIntegrationButton')) {
            if (typeof userData?.hasClickedIntegrationButton === 'boolean') {
                if (!userData?.hasClickedIntegrationButton) {
                    setOpen(true);
                }
            }
        }
    }, [userData]);

    return (
        <Modal open={open} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <IconButton
                    disableRipple
                    sx={{
                        position: 'absolute',
                        top: '28px',
                        right: '28px',
                        padding: '0',
                        svg: {
                            path: {
                                fill: '#FBB414'
                            }
                        }
                    }}
                    onClick={handleCloseModal}
                >
                    <CloseOutlinedIcon />
                </IconButton>
                <Chip
                    label="Premium"
                    icon={<DiamondOutlinedIcon />}
                    sx={{
                        background: 'rgba(0, 33, 77, 0.20)',
                        color: '#00214D',
                        display: 'inline-flex',
                        padding: '6px 8px',
                        marginBottom: '10px',

                        '.MuiSvgIcon-root': {
                            width: '18px',
                            height: '18px',
                            margin: '0',
                            path: {
                                fill: '#00214D'
                            }
                        },
                        '.MuiChip-label': {
                            padding: '0 0 0 8px'
                        }
                    }}
                />
                <Stack gap={3}>
                    <Typography id="modal-modal-title" variant="h2" component="h2">
                        Integrate Diolog questions into your platform!
                    </Typography>
                    <Typography color="#676767" fontSize="1rem" lineHeight="1.375rem">
                        Seamlessly integrate Diolog with your existing investor website or portal.
                    </Typography>
                    <Typography color="#676767" fontSize="1rem" lineHeight="1.375rem">
                        The Diolog question plugin allows you to build better connections with investors no matter if they have downloaded
                        the Diolog app or not. Questions received through the Diolog website integration will appear on your questions board
                        where you can reply with ease.
                    </Typography>
                    <Typography color="#676767" fontSize="1rem" lineHeight="1.375rem">
                        Engage your investors at every touchpoint
                    </Typography>
                    <Box
                        sx={{
                            background: '#FFC23A',
                            border: '1px solid #E5E5E8',
                            borderRadius: '12px',
                            paddingTop: '28.25%',
                            // padding: '0 24px',
                            // height: '205px',
                            position: 'relative',
                            overflow: 'hidden',

                            '& video': {
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }
                        }}
                    >
                        <video autoPlay loop muted id="video">
                            <source src={QuestionAnimationVideo} type="video/mp4" />
                            <track kind="captions"></track>
                        </video>
                    </Box>

                    {/* <Box>{QuestionAnimationVideo && <video src={QuestionAnimationVideo} type="video/mp4" />}</Box> */}
                    {/* <Box
                        className={`image-anim `}
                        sx={{
                            background: '#FFC23A',
                            border: '1px solid #E5E5E8',
                            borderRadius: '12px',
                            padding: '0 24px'
                        }}
                    >
                        <img
                            src={Image}
                            alt="Integrate web form"
                            id="animating-image"
                            className={`${isDelayed ? 'stop' : ''}`}
                            // onAnimationEnd={handleAnimationIteration}
                            // onAnimationIteration={handleAnimationIteration}
                            // onAnimationEnd={handleAnimationEnd}
                        />
                    </Box> */}

                    {/* <Box
                        className="image-animation"
                        sx={{
                            background: '#FFC23A',
                            border: '1px solid #E5E5E8',
                            borderRadius: '12px',
                            // padding: '24px 24px 0'
                            padding: '0 24px'
                        }}
                    >
                        <Slider {...settings}>
                            <Box>
                                <img src={Image} alt="Integrate web form" />
                            </Box>
                            <Box>
                                <img src={Image} alt="Integrate web form" />
                            </Box>
                        </Slider>
                    </Box> */}

                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        gap={1}
                        sx={{
                            '.MuiButton-root': {
                                borderRadius: '12px',
                                minWidth: '157px'
                            }
                        }}
                    >
                        <Button variant="outlined" size="large" className="alternate-reversed" onClick={handleCloseModal} disableRipple>
                            Close
                        </Button>
                        <Button variant="contained" size="large" className="alternate" disableRipple onClick={onClickButton}>
                            {checkIsPremiumPlan(companyData?.subscription?.plan) ? 'Get started now!' : 'Upgrade'}
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default IntegrateDiologQuestions;
